import { render, staticRenderFns } from "./modal-edit-order-delivery.vue?vue&type=template&id=efed62e4&"
import script from "./modal-edit-order-delivery.vue?vue&type=script&lang=js&"
export * from "./modal-edit-order-delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports